<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.garantie.shop.vendeur')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected && selected[0].value && selected.length > 0 && selected[0].type != 'auto'">
                    <div v-if="selected[0].value.ville" class="font-bold">{{$addressTool.capitalizeTown(selected[0].value.ville) + selected[0].value.cp}}</div>
                    <div v-if="selected[0].value.img" class="text-xs font-light"><img class="h-4" :src="selected[0].value.img" /></div>
                </template>
                <template v-if="selected == '-1'">
                    <span class="font-bold">{{$t('form.garantie.shop.lieu_d_achat_introuvable')}}</span>
                </template>
                <template v-if="selected == '-2'">
                    <div class="font-bold">{{$formTool.getFormData('new-shop').ville}}</div>
                    <div class="font-light text-sm">{{$formTool.getFormData('new-shop').cp}}</div>
                </template>
            </template>

            <template v-slot:open>
                <sav-spinner v-if="loading" :size="10" />
                <!-- Get shop in list -->
                <template v-if="!displayNewShopForm">
                    <sav-form
                    v-if="data"
                    :data-src="data"
                    :callback="end"
                    :id="$options.name"
                    />
                    <button @click="changeToNewForm" class="p-2 px-3 text-sm duration-200 bg-gray-100 border border-gray-300 hover:bg-gray-200 rounded-xl">
                        {{$t('form.garantie.shop.lieu_d_achat_introuvable')}}
                    </button>
                </template>
                <!-- Add new shop -->
                <template v-if="displayNewShopForm">
                    <!-- Return to shop list -->
                    <button @click="displayNewShopForm = false" v-if="$formTool.getFormData('sign').id" class="bg-slate-100 hover:bg-slate-200 duration-200 cursor-pointer rounded px-4 py-2 mb-3 text-sm"><i class="fas fa-arrow-left mr-1"></i> {{ $tt('Retour à la liste') }}</button>
                    <!-- Pays -->
                    <sav-input :label="$tt('Pays')" type="select" v-model="newShop.pays" :options="{ label: 'name', values: countries }" class="mb-3" />
                    <!-- Code postal -->
                    <sav-input v-if="newShop.pays" @input="getVilles" v-model="newShop.cp" type="text" :label="$tt('Code postal')" class="mb-3" />
                    <!-- Ville -->
                    <template v-if="villes && villes.length > 0 && newShop.pays.code == 'FR'">
                        <sav-input
                        class="w-full mb-3"
                        :label="$tt('Ville')"
                        type="select"
                        v-model="newShop.ville"
                        :options="{
                            label: 'ville_nom_reel',
                            key: 'ville_nom_reel',
                            values: villes
                        }"
                        />
                    </template>
                    <!-- Input ville pays etranger -->
                    <sav-input v-if="newShop.pays.code != 'FR'" v-model="newShop.ville" type="text" :label="$tt('Ville')" />
                    <!-- Button valider -->
                    <button @click="addNewShop" class="mt-3 px-4 py-2 rounded-lg bg-green-500 hover:bg-green-600 cursor-pointer duration-200 mt-2 text-white">{{ $tt('Valider') }} <i class="fas fa-check ml-1"></i></button>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import countriesList from '@/json/countries.json'

export default {
    name: 'shop',
    extends: FormCardExtension,

    watch: {
        open: function(value) {
            if (value === true) {
                this.data[0].value = null
            }
        }
    },

    data() {
        return {
            displayNewShopForm: false,
            newShop: {
                pays: null,
                ville: null,
                cp: null
            },
            villes: []
        }
    },

    computed: {
        countries() {
            this.newShop.pays = countriesList.find((item) => item.code == 'FR')
            return countriesList 
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            let localStorageData = this.$formTool.getFormData(this.$options.name)
            if (localStorageData && localStorageData != '-1' && localStorageData != '-2' && localStorageData[0].value.ville) {
                localStorageData = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                if (localStorageData[0].type != 'auto') {
                    this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                    this.nextBlock = this.$formTool.blockData(this.$options.name).next
                }
            } else if (localStorageData == '-1' || localStorageData == '-2') {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            } else {
                if (this.$formTool.getFormData('sign') && this.$formTool.getFormData('sign').requested) {
                    let sign = this.$formTool.getFormData('sign')
                    this.$formTool.addFormData(this.$options.name, [{value:{id: sign.id, name: sign.label, ville: null, cp: null, img: null, townAndZipCode: null}}])
                    this.nextBlock = this.$formTool.blockData(this.$options.name).next
                    this.$parent.removeLastBlock()
                    this.emitChange()
                }
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            let sign = this.$formTool.getFormData('sign')
            // Not ask shop for new website
            if (!sign.id && sign.ecommerce == 1) {
                this.$parent.removeLastBlock()
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                this.emitChange()
            }
            if (sign.id) {
                // Get api data
                this.data = []
                let response = await apiService.post('getshop', {
                    id_enseigne: this.$formTool.getFormData('sign').id
                })
                let shops = response.data.posts.post
                if ((shops.length == 0 && response.data.posts.id_mag)) {
                    this.$parent.removeLastBlock()
                    this.nextBlock = this.$formTool.blockData(this.$options.name).next
                    this.$formTool.addFormData(this.$options.name, [{type: 'auto', value: {id: response.data.posts.id_mag}}])
                    this.emitChange()
                }
    
                this.data = [
                    {
                        type: 'sav-select',
                        options: {
                            label: 'townAndZipCode',
                            values: shops.map(shop => ({
                                ...shop,
                                townAndZipCode: this.$addressTool.capitalizeTown(shop.ville) + shop.cp,
                                moreData: this.$formTool.blockData(this.$options.name).meta && this.$formTool.blockData(this.$options.name).meta.codeMag ? shop.code_mag : null,
                                img: this.$formTool.getFormData('sign').img
                            })),
                            required: true
                        }
                    }
                ]
                
            } else {
                // Manage new sign, add new shop
                this.displayNewShopForm = true
            }
            this.loading = false
        },

        end(callbackData) {
            // -1 : Magasin introuvable
            // -2 : Nouveau magasin
            if (callbackData != '-1' && callbackData != '-2') {
                let emptyValues = callbackData.find(element => element.value == null)
                if (!emptyValues) {
                    let saveValue = JSON.parse(JSON.stringify(callbackData))
                    delete saveValue[0].options.values
                    this.$formTool.addFormData(this.$options.name, saveValue)
                    this.nextBlock = this.$formTool.blockData(this.$options.name).next
                    if (this.selected) {
                        this.$emit('update', this.$options.name)
                    }
                    this.selected = JSON.parse(JSON.stringify(callbackData))
                }
            } else if (callbackData == '-1') {
                this.$formTool.addFormData(this.$options.name, '-1')
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                if (this.selected == '-1') {
                    this.selected = null
                }
                this.selected = '-1'
            } else if (callbackData == '-2') {
                this.$formTool.addFormData(this.$options.name, '-2')
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                if (this.selected == '-2') {
                    this.selected = null
                }
                this.selected = '-2'
            }
        },

        changeToNewForm() {
            this.displayNewShopForm = true
        },

        addNewShop() {
            if (!this.newShop.pays) {
                this.$toast.error(this.$tt('Le champ Pays est obligatoire'))
                return
            }
            if (!this.newShop.cp) {
                this.$toast.error(this.$tt('Le champ Code postal est obligatoire'))
                return
            }
            if (!this.villes || (this.villes.length <= 0 && !this.newShop.ville)) {
                this.$toast.error(this.$tt('Le code postal est invalide'))
                return
            }
            if (!this.newShop.ville) {
                this.$toast.error(this.$tt('Le champ Ville est obligatoire'))
                return
            }
            this.$formTool.addFormData('new-shop', {
                pays: this.newShop.pays,
                ville: this.newShop.ville,
                cp: this.newShop.cp
            })
            this.end('-2')
        },

        async getVilles() {
            if (this.newShop.cp && this.newShop.cp.length == 5 && this.newShop.pays.code == 'FR') {
                let response = await apiService.post('get_ville', {
                    cp_mag: this.newShop.cp
                })
                if (response.data.posts.post[0]) {
                    this.newShop.ville = response.data.posts.post[0].ville_nom_reel
                }
                this.$nextTick(() => {
                    this.villes = response.data.posts.post
                })
            } else {
                this.villes = []
                this.newShop.ville = null 
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/ShopCard.vue